<div id="chat-button">
    <img class="custom-grid-icon" id="chat-button-img" src="assets/layout/images/chat-2-icon.png" alt="" title="" (click)="showChatBox()">
    <span *ngIf="unreadCount !== undefined && unreadCount > 0" class="button__badge">{{unreadCount}}</span>
</div>
<div id="chat-box">
    <iframe id="chatIFrame" [src]="urlSafe" frameborder="0" class="chat-frame"></iframe>
</div>